import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import { authLoginRequest } from '../../../../action/auth-actions'
import LoginWithFacebook from '../login-with-facebook/index'
import LoginWithGoogle from '../login-with-google/index'
import Fingerprint2 from 'fingerprintjs2'
import { setLoading } from '../../../../action/loading-actions'
import logoIcon from '../../../../../asset/BaseMapLogo.png'

class LoginDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      ipAddress: '',
      platform: '',
      error: '',
      confirmPassword: '',
      passwordsMatch: true,
      login: false,
      bgColor: ''
    }
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    this.getIpAddress()
    this.getPlatform()
    this.props.setLoading(false);
  }

  getPlatform() {
    const options = {}
    Fingerprint2.getV18(options,
      function (results, components) {
        let platform = components[14].value
        this.setState({ platform: platform })
      }.bind(this)
    )
  }

  getIpAddress() {
  }

  handleLogin(e) {
    e.preventDefault();
    this.handleLoginButton()
  }

  handleLoginButton = () => {
    if (this.validateEmail(this.state.email) && this.state.password.length >= 8) {
      this.props.setLoading(true)
      const authObj = {
        Email: this.state.email,
        Password: this.state.password,
        IpAddress: this.state.ipAddress,
        Platform: this.state.platform
      }
      this.props.authLogin(authObj).then(res => {
        let err = res.message ? res : null
        let emailError = ''
        if (err) {
          this.props.setLoading(false)
          switch (err.status) {
            case 401:
              emailError = 'Invalid password or email.'
              break
            case 503:
              emailError = 'BaseMap is offline for updates.'
              break
            case 504:
              emailError = 'BaseMap is offline for updates.'
              break
            default:
              emailError = 'There is an error with your email or password'
          }
          this.setState({ error: emailError })
          return
        } else {
        }
      }).catch(e => {
        console.log(e);
        this.props.setLoading(false)
        this.setState({ error: 'Invalid password or email.' })
        return
      })
    } else {
      this.setState({ error: 'Invalid password or email.' })
    }
  }

  handleChange(event) {
    const { name, value } = event.target
    this.setState({
      [name]: value,
      error: ''
    })
  }

  handleBlur(event) {
    const { value, name } = event.target;
    if (name == "email") {
      if (!this.validateEmail(this.state.email)) {
        this.setState({
          error: 'Invalid email format'
        });
      }
    }
    if (name == "password") {
      if (value.length < 8) {
        this.setState({
          error: 'Password should be min 8 characters'
        });
      }
    }
  }

  validateEmail(email) {
    console.log('validate')
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    this.setState({
      password: newPassword,
      error: ' ',
      bgColor: this.state.email ? '#589500' : '#C4C4C4'
    });
  };

  handleconfirmPsd = (e) => {
    const newConfirmPassword = e.target.value;
    this.setState({
      confirmPassword: newConfirmPassword,
      passwordsMatch: newConfirmPassword === this.state.password,
      error: ''
    });
  };

  render() {
    const boxId = 'login-dialog'
    const css = {
      id: boxId,
      parent: boxId + '-parent',
      header: boxId + '__header',
      body: boxId + '__body',
      footer: boxId + '__footer'
    }
    const content = {
      header: (
        <>
          <div style={{ width: 50, height: 30 }}>
            <a onClick={e => this.setState({ login: false })} style={{ width: '50%', margin: '0.5em', height: 40, color: '#959595', marginBottom: 10 }}>
              Back
            </a>
          </div>
          <div>
            <img src={logoIcon} style={{ width: '100%', height: 31 }}></img>
          </div>
        </>
      ),
      body: (
        <React.Fragment>
          <p style={{ marginTop: 5, marginBottom: 20, textAlign: 'center', color: '#959595' }}>Login</p>
          <div />
          <div>
            <label>Email</label>
            <input
              type="email"
              name="email"
              autoComplete="email"
              value={this.state.email}
              onChange={event => this.handleChange(event)}
              className='login-email-input-style'
              onBlur={this.handleBlur}
            />
          </div>
          <div>
            <label>
              Password<span> (min 8 characters)</span>
            </label>
            <input
              type="password"
              name="password"
              value={this.state.password}
              onChange={event => this.handlePasswordChange(event)}
              className='login-email-input-style'
              onBlur={this.handleBlur}
            />
          </div>
          <div style={{
            width: '100%',
            justifyContent: 'flex-end',
            display: 'flex',
          }}>
            <p style={{
              textAlign: 'center',
              font: 'normal normal normal 12px/16px Segoe UI',
              letterSpacing: '-0.45px',
              color: '#959595',
              opacity: 1,
              marginBottom: '10px' // Add margin-bottom for space
            }}>
              <a href="#forgot-Password" onClick={e => this.props.slideInOutBackground('forgotPassword')} style={{ textDecoration: 'none', color: '#959595' }}>
                <span > Forgot password?</span>
                <span className="custom-link-login-forgot-psd"> Click Here</span>
              </a>
            </p>
          </div>
          <div style={{ width: '100%' }}>
            <p id="login-email-error" style={{ textAlign: 'center', color: 'red', fontSize: 12 }} >{this.state.error}</p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: this.state.error ? 10 : 20, width: '100%', }}>
            <button className='login-button-style' type="submit" value="Submit" onClick={e => this.handleLogin(e)} style={{ width: "100%", margin: '0.5em', height: 40, backgroundColor: this.state.bgColor }}>
              Login
            </button>
          </div>
        </React.Fragment>
      ),
      signup: (
        <div style={{
          width: '100%',
          height: '100%',
          alignItems: 'flex-end',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <p style={{
            textAlign: 'center',
            font: 'normal normal normal 15px/20px Roboto',
            letterSpacing: '-0.45px',
            color: '#959595',
            opacity: 1,
            marginBottom: '10px' // Add margin-bottom for space
          }}>
            <a target="_blank" rel="noopener noreferrer" onClick={e => this.props.slideInOutBackground('showSignUpFromLogin')}   >
              <span style={{ color: '#959595', textDecoration: 'none' }}> New User?</span>
              <span className="custom-link-login"> Create Account</span>
            </a>
          </p>
        </div>
      ),

      footer: (
        <React.Fragment>
          <div style={{ paddingBottom: '25px' }} className='terms-condition-style'>
            <p className='terms-condition-style'>
              By logging-in you agree to our &nbsp;
              <a
                href="https://www.basemap.com/terms-of-use/"
                target='_blank'
                onClick={() => {
                  this.props.openTermsUpdate()
                }}
              >
                terms of service.
              </a>
            </p>
          </div>

          <div />
        </React.Fragment>
      )
    }
    return (
      <div style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        {this.state.login ?
          <>
            <div style={{ height: '50vh', width: '320px', minHeight: 500, maxHeight: 550, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ height: '20%', }}>
                <div style={{}}>{content.header}</div>
              </div>
              <div style={{ height: '60%', width: '100%', }}>
                {content.body}
              </div>
              <div style={{ height: '20%', width: '100%', }}>
                <div style={{ width: '100%' }}>
                  {content.footer}
                  {content.signup}
                </div>
              </div>
            </div>
          </>
          :
          <div id={css.id} className='login-container-style'>
            <div className='login-container-child-style' style={{ height: '14%', display: 'flex', alignItems: 'flex-start' }}>
              <img src={logoIcon} style={{ width: '100%', height: 31, }}></img>
            </div>
            <div className='login-container-child-style-text' style={{ height: '10%' }}>
              <span className='centered-text-login'>Login</span>
            </div>
            <div className='login-container-child-style' style={{ height: '10%' }}>
              <button className="green-button-signin" style={{ margin: '1em 0' }} onClick={() => this.setState({ login: true })}> <span className='centered-text'>Email</span></button>
            </div>
            <div className='login-container-child-style' style={{ height: '10%' }}>
              <LoginWithFacebook />
            </div>
            <div className='login-container-child-style' style={{ height: '10%' }}>
              <LoginWithGoogle />
            </div>

            <div className='login-container-child-style' style={{ height: '14%' }}>
              {content.signup}
            </div>
            <div className='login-container-child-style' style={{ height: '20%' }}>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'center', height: '100%', alignItems: 'flex-end' }}>
                <p style={{
                  textAlign: 'center',
                  font: 'normal normal normal 15px/20px Roboto',
                  letterSpacing: '-0.45px',
                  color: '#959595',
                  opacity: 1,
                  marginBottom: '10px' // Add margin-bottom for space
                }}>
                  Return to <a href="https://www.basemap.com/" target="_blank" rel="noopener noreferrer" className="custom-link" onClick={() => { console.log('clicked basemap') }}>
                    www.basemap.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        }
      </div>

    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  authLogin: bmAuthObj => dispatch(authLoginRequest(bmAuthObj)),
  setLoading: bool => dispatch(setLoading(bool))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginDialog)
